import React from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { SimplePricingCardTitle } from '../../../Constant';
import { PricingDetailData } from '../../../Data/Ecommerce/PricingCardData';
import PricingDetail from './PricingDetail';

const PricingDetailCard = () => {
  return (
    <Col sm='12'>
      <Card>
        <CardHeader className='pb-0'>
          <H5>{SimplePricingCardTitle}</H5>
        </CardHeader>
        <CardBody className='pricing-content'>
          <Row className='pricing-col'>
            {PricingDetailData.map((item, i) => (
              <Col xl='3' sm='6' className='xl-25 box-col-3' key={i}>
                <PricingDetail data={item} />
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PricingDetailCard;
